import React, { useRef, useState } from "react";
import axios from "axios";
import styled from "styled-components";
import { debounce } from "lodash";
import { FormRow, FormRowMessage, FormTextbox, TitleStack, BlockButton, Spinner } from "fiver-react-ui-components";
const StyledWrapper = styled.div``;
export const StyledSpinner = styled(Spinner)`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 1rem;
  margin: auto;
`;

const SignupStep = ({
  translations,
  onStepClicked,
  isStepValid,
  values,
  errors,
  dirty,
  handleChange,
  handleBlur,
  setFieldTouched,
  touched
}) => {
  const [asyncUsernameError, setAsyncUsernameError] = useState();
  const [usernameLoading, setUsernameLoading] = useState(false);

  const handleChangeUsername = async (e, callback) => {
    const {
      value,
      name
    } = e.target;

    if (value.length >= 5 && value.length <= 30) {
      setUsernameLoading(true);
      await axios.get(`/users/username/${value}`).then(({
        data
      }) => {
        setUsernameLoading(false);

        if (!data.available) {
          setAsyncUsernameError(translations.existsUserName);
        } else {
          setAsyncUsernameError(undefined);
        }
      }).catch(() => {
        setUsernameLoading(false);
        setAsyncUsernameError("Something went wrong!");
      });
    }

    callback(name, true, true);
  };

  const refHandlerUsername = useRef(debounce(handleChangeUsername, 350));
  return /*#__PURE__*/React.createElement(StyledWrapper, null, /*#__PURE__*/React.createElement(TitleStack, {
    title: `${translations.step} 3`,
    subtitle: translations.messageSecurityDetails
  }), /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormTextbox, {
    name: "username",
    placeholder: translations.username,
    value: values.username,
    isRequired: true,
    isError: values.username !== "" && errors.username || asyncUsernameError,
    onChange: e => {
      handleChange(e);
      refHandlerUsername.current(e, setFieldTouched);
    },
    onBlur: handleBlur
  }), usernameLoading && /*#__PURE__*/React.createElement(StyledSpinner, {
    lineWidth: 5
  })), /*#__PURE__*/React.createElement(FormRowMessage, {
    isVisible: values.username !== "" && errors.username || asyncUsernameError
  }, errors.username, !errors.username ? asyncUsernameError : ""), /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormTextbox, {
    onChange: handleChange,
    onBlur: handleBlur,
    isRequired: true,
    isError: values.password !== "" && errors.password,
    value: values.password,
    name: "password",
    type: "password",
    placeholder: translations.password
  })), /*#__PURE__*/React.createElement(FormRowMessage, {
    isVisible: values.password !== "" && errors.password
  }, errors.password), /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormTextbox, {
    onChange: handleChange,
    onBlur: handleBlur,
    isRequired: true,
    isError: values.passwordConfirm !== "" && errors.passwordConfirm,
    value: values.passwordConfirm,
    name: "passwordConfirm",
    type: "password",
    placeholder: translations.confirmPassword
  })), /*#__PURE__*/React.createElement(FormRowMessage, {
    isVisible: values.passwordConfirm !== "" && errors.passwordConfirm
  }, errors.passwordConfirm), /*#__PURE__*/React.createElement(BlockButton, {
    onClick: () => onStepClicked(3),
    disabled: !dirty || !isStepValid || asyncUsernameError,
    style: {
      marginBottom: "1rem"
    }
  }, translations.next), /*#__PURE__*/React.createElement(BlockButton, {
    onClick: () => onStepClicked(1)
  }, translations.back));
};

export default SignupStep;